import { ComponentPropsTransformer } from "../../../data/transformer/componentTransformer.ts";

export type UnknownPropsTransformMap = Record<
  string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  | ComponentPropsTransformer<any, any>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  | (() => Promise<ComponentPropsTransformer<any, any>>)
>;

export type ComponentContentPropsTransformMap =
  typeof componentContentPropsTransformMap;

export const componentContentPropsTransformMap = {
  C101Hero: () =>
    import("../../cms-components/C101Hero/C101Hero.transformer").then(
      (module) => module.c101HeroTransformer,
    ),
  C103TextBlock: () =>
    import("../../cms-components/C103TextBlock/C103TextBlock.transformer").then(
      (module) => module.c103TextBlockTransformer,
    ),
  C104WorkshopProgram: () =>
    import(
      "../../cms-components/C104WorkshopProgram/C104WorkshopProgram.transformer"
    ).then((module) => module.c104WorkshopProgramTransformer),
  C105NotesCarousel: () =>
    import(
      "../../cms-components/C105NotesCarousel/C105NotesCarousel.transformer"
    ).then((module) => module.c105NotesCarouselTransformer),
  C106Instructors: () =>
    import(
      "../../cms-components/C106Instructors/C106Instructors.transformer"
    ).then((module) => module.c106InstructorsTransformer),
  C107Challenge: () =>
    import("../../cms-components/C107Challenge/C107Challenge.transformer").then(
      (module) => module.c107ChallengeTransformer,
    ),
  C108ApplicationTerms: () =>
    import(
      "../../cms-components/C108ApplicationTerms/C108ApplicationTerms.transformer"
    ).then((module) => module.c108ApplicationTermsTransformer),
  C109Timeline: () =>
    import("../../cms-components/C109Timeline/C109Timeline.transformer").then(
      (module) => module.c109TimelineTransformer,
    ),
  C110CallToAction: () =>
    import(
      "../../cms-components/C110CallToAction/C110CallToAction.transformer"
    ).then((module) => module.c110CallToActionTransformer),
  C111Faq: () =>
    import("../../cms-components/C111Faq/C111Faq.transformer").then(
      (module) => module.c111FaqTransformer,
    ),
  C112RichText: () =>
    import("../../cms-components/C112RichText/C112RichText.transformer").then(
      (module) => module.c112RichTextTransformer,
    ),
  C113Winners: () =>
    import("../../cms-components/C113Winners/C113Winners.transformer").then(
      (module) => module.c113WinnersTransformer,
    ),
} as const satisfies UnknownPropsTransformMap;

export const propsTransformMap = {
  ...componentContentPropsTransformMap,
} as const satisfies UnknownPropsTransformMap;
